type FetchFn<T> = () => Promise<T>;

type CacheEntry<T> = { ts: number; value: T };

export function createFetcherWithTTL(ttl = 60_000) {
  const cache = new Map<string, CacheEntry<unknown>>();
  const inFlight = new Map<string, Promise<unknown>>();

  return function fetchWithCache<T>(
    key: string,
    fetchFn: FetchFn<T>
  ): Promise<T> {
    const now = Date.now();

    const cached = cache.get(key);
    if (cached && now - cached.ts < ttl) {
      return Promise.resolve(cached.value) as Promise<T>;
    }

    if (inFlight.has(key)) {
      return inFlight.get(key)! as Promise<T>;
    }

    const promise = fetchFn()
      .then((value) => {
        cache.set(key, { ts: Date.now(), value });
        inFlight.delete(key);
        return value;
      })
      .catch((err) => {
        inFlight.delete(key);
        throw err;
      });

    inFlight.set(key, promise);
    return promise;
  };
}

export const cache5Min = createFetcherWithTTL(5 * 60_000);
